module.exports = __webpack_public_path__ + "img/card-with-logo.1caa42e2.png";